module.exports = __webpack_public_path__ + "static/media/icon-print.60488598.svg";